import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ProductCatalogActions } from './product-catalog.actions';
import {UserProductCatalogClient} from '@api/api-service';
@Injectable()
export class ProductCatalogEffects {
  private actions$ = inject(Actions);
  private userProductCatalogPublicClient = inject(UserProductCatalogClient);

  // ==================== GET PRODUCT CATALOG (PREVIEW MODE) ====================
  getProductCatalog$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProductCatalogActions.getProductCatalog),
      switchMap(({ userId, productCatalogId }) => {
          return this.userProductCatalogPublicClient.getUserProductCatalog(userId, productCatalogId).pipe(
            map((response) => { return ProductCatalogActions.getProductCatalogSuccess({ response })}),
            catchError((error) => of(ProductCatalogActions.getProductCatalogFailure({ error })))
          );
      })
    )
  )
}
